// The two SOAR feature flags, as the BE now returns them on GET /inventory/venue/{id}
// (SVEMS-998). `venue.page.js` spreads the raw venue response onto the venue it puts in
// VenueContext, so both fields are already there — read them through these two helpers
// rather than reaching for the raw field, so the gates stay greppable.
//
// Both take the venue from VenueContext, which is null until the venue request resolves,
// and every gate reads them on the first render — hence the coercion.
//
// For deciding WHICH FIELD OF A BOOKING PAYLOAD TO READ, use `isEatappSource(src.source)`
// from `booking.service.js` instead: that is a property of the record, not of the venue.
// An EatApp reservation carries its bill on `amount` and its notes on `note` whatever
// venue it is being viewed from, so those choices must follow the record.

// An Odoo venue keeps its supply cost and mark up inside Odoo, so the dashboard does not
// show those two fields on the product form.
export const isOdooVenue = (venue) => Boolean(venue?.odooIntegration);

// A SOAR venue gets the reservation wording, the Manifest columns and the pre-checkin
// fields; every other venue keeps the older booking screens.
export const isEatappVenue = (venue) => Boolean(venue?.eatAppIntegration);
